import React from 'react';
import PropTypes from 'prop-types';
import ScheduleRowField from './scheduleRowField';
import getDayConflicts from './getDayConflicts';

const MONDAY = 1;
const SUNDAY = 7;

const orderFieldsByWeekday = (fields, firstDayOfWeek) => {
  const distanceFromFirstDay = day => (day - firstDayOfWeek + 7) % 7;

  return fields
    .map((reduxFormFieldKey, idx) => {
      const reduxFormFieldValue = fields.get(idx);
      return [reduxFormFieldKey, reduxFormFieldValue];
    })
    .sort((a, b) => distanceFromFirstDay(a[1].weekDay) - distanceFromFirstDay(b[1].weekDay))
    .map(([reduxFormFieldKey]) => reduxFormFieldKey);
};

const ScheduleRow = ({ conflicts, disabled, fields, times }) => (
  <div className="barber-schedule-row">
    {
      orderFieldsByWeekday(fields, SUNDAY)
        .map(day => (
          <ScheduleRowField
            day={day}
            dayConflicts={getDayConflicts(day, conflicts)}
            key={day}
            disabled={disabled}
            times={times}
          />
        ))
    }
  </div>
);

ScheduleRow.propTypes = {
  conflicts: PropTypes.array,
  disabled: PropTypes.bool,
  fields: PropTypes.array.isRequired,
  times: PropTypes.array.isRequired,
};

ScheduleRow.defaultProps = {
  conflicts: [],
  disabled: false,
};

export default ScheduleRow;
